const experience = [
  {
    id: 1,
    year: 2022,
    text: 'Desenvolvedor fullstack - BWM Technologie ',
    desc: 'Desenvolvendo projetos em parceria com a Bonassoli Tech ',
  },
  {
    id: 2,
    year: 2020,
    text: 'Início da Jornada Dev',
    desc: 'Início da jornada de aprendizado de desenvolvimento',
  },
  {
    id: 3,
    year: 2018,
    text: 'Suporte tec de Ti',
    desc: 'Atendimento on demand para empresas na área de informática',
  },
  {
    id: 4,
    year: 2010,
    text: 'Técnico de informática',
    desc:
      'Formatação e otimização de sistemas operacionais, manutenção de hardware',
  },
];
export default experience;
